import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
let InfoTitle = class InfoTitle extends Vue {
};
InfoTitle = __decorate([
    Component
], InfoTitle);
export default InfoTitle;
